import script from "./Szkg.vue?vue&type=script&setup=true&lang=js"
export * from "./Szkg.vue?vue&type=script&setup=true&lang=js"

import "./Szkg.vue?vue&type=style&index=0&id=03596cc4&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03596cc4"]])

export default __exports__